import React from 'react'
import { COLORS } from '@btime/constants'

import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import { HorizontalLine } from '../../../../../components/shapes/Line'

const SectionsSeparator = () => {
  return (
    <>
      <Separator weight={2} />
      <HorizontalLine thin lineColor={COLORS.light1} />
      <Separator weight={6} />
    </>
  )
}

export default SectionsSeparator
